import React from "react";
import { useSelector } from "react-redux";

import bankersRounding from "bankers-rounding";
import _ from "lodash";

const CurrencyConvertor = ({ price = 0, className = "", primaryDiscountType = "", isShorthand = false, ...otherProps }) => {
  const { currency, exchange_rate } = useSelector((state) => state.user_preference);

  // Get numeric value from price
  const rawPrice = price && typeof price === "object" && !_.isNil(price.raw) ? price.raw : price;

  // Convert and round price
  const convertedPrice = bankersRounding(rawPrice * exchange_rate, 2);

  // Figure out a price color class from discount type
  let price_color_class = "";
  if (primaryDiscountType === "hippoOffer") {
    price_color_class = "hippo-offer";
  } else if (primaryDiscountType === "customPromotion") {
    price_color_class = "custom-promotion";
  }

  // Get the user locale (e.g. "en-US", "de-DE", etc.)
  const userLocale = navigator.language;

  // Format it (shorthand if requested)
  const formattedPrice = formatPrice(convertedPrice, userLocale, currency, isShorthand);

  return (
    <span className={`${className} ${price_color_class}`} {...otherProps}>
      {formattedPrice}
    </span>
  );
};

export default CurrencyConvertor;

/**
 * Formats the price using Intl.NumberFormat.
 * If isShorthand=true, it uses 'compact' notation (e.g. $1.2K, $1.3M).
 */
function formatPrice(price, locale = "default", currency = "USD", isShorthand = false) {
  const options = {
    style: "currency",
    currency: currency,
    // You can customize precision here if desired:
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };

  if (isShorthand) {
    // Compact notation => will produce K, M, B, etc. depending on the magnitude.
    options.notation = "compact";
    options.compactDisplay = "short";
    // If you want fewer decimals when in shorthand mode, uncomment:
    // options.maximumFractionDigits = 1; // e.g. $1.2K instead of $1.23K
  }

  return new Intl.NumberFormat(locale, options).format(price);
}

export { formatPrice };
